import axios from 'axios'
import HttpStatus from 'http-status-codes'
import { refreshAccessTokenSuccess } from '../../actions/AuthAction'
import store from '../../Store'
import * as routeService from '../routeService'

const baseUrlV2 = process.env.REACT_APP_API_V2

let isRefreshingAccessToken = false

// Helpers
const getRefreshToken = () => {
  const state = store.getState()
  if (!state.AuthReducer.user || !state.AuthReducer.user.refreshToken) {
    return
  }
  return state.AuthReducer.user.refreshToken
}

let waitingForRefreshingAccessTokenCompletion = []

const waitForRefreshingAccessTokenCompletion = () =>
  new Promise((resolve, reject) => {
    waitingForRefreshingAccessTokenCompletion.push({ resolve, reject })
  })

const refreshAccessToken = async refreshToken => {
  try {
    // Queue retrying request if refresh already in progress
    if (isRefreshingAccessToken) {
      console.warn('Refreshing access token already in progress. Waiting for completion...')
      await waitForRefreshingAccessTokenCompletion()
      return true
    }

    console.warn('Refreshing access token started')

    isRefreshingAccessToken = true

    // Refresh call
    const { data } = await axios.post(`${baseUrlV2}/v2/auth/token-refresh`, {
      refreshToken,
    })

    // Store new tokens in store
    store.dispatch(refreshAccessTokenSuccess({ accessToken: data.accessToken, refreshToken: data.refreshToken }))

    isRefreshingAccessToken = false

    // Resolve & clear queue of pending calls
    waitingForRefreshingAccessTokenCompletion.forEach(completion => {
      completion.resolve()
    })
    waitingForRefreshingAccessTokenCompletion = []

    return data.accessToken
  } catch (error) {
    console.warn('Refreshing access token failed with error: ', error)

    isRefreshingAccessToken = false

    // Reject & clear queue of pending calls
    waitingForRefreshingAccessTokenCompletion.forEach(completion => {
      completion.reject(error)
    })
    waitingForRefreshingAccessTokenCompletion = []

    // Logout if refreshing token failed
    const axiosError = error
    if (axiosError && axiosError.response && axiosError.response.status !== HttpStatus.OK) {
      store.dispatch({ type: 'LOGOUT_USER' })
      routeService.goToLoginPage()
    }

    return undefined
  }
}

// Interceptors
const success = response => response

const error = async error => {
  if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
    console.warn(`${HttpStatus.UNAUTHORIZED} for request`, error)

    // Get refresh token
    const refreshToken = getRefreshToken()
    if (!refreshToken) {
      store.dispatch({ type: 'LOGOUT_USER' })
      routeService.goToLoginPage()

      return Promise.reject(error)
    }

    // Refresh access token
    const newAccessToken = await refreshAccessToken(refreshToken)
    if (!newAccessToken) {
      return
    }

    // Check new access token
    if (!newAccessToken) {
      return Promise.reject(error)
    }

    // Retry original call
    const newConfig = error.config
    newConfig.headers.Authorization = newAccessToken
    return Promise.resolve(axios(newConfig))
  }

  return Promise.reject(error)
}

export default {
  success,
  error,
}



// WEBPACK FOOTER //
// ./src/services/interceptors/interceptor.response.refreshAccessToken.js